export default function fieldShowRegion(value) {
	//[ { "id ": "86", "name": "中国大陆" }, { "id": "110000", "name": "北京市" } ]
	if (!value) {
		return "";
	}
	return value
		.map(val => {
			return val.name;
		})
		.join("/");
}